export default {
      id: "ic_punishment_yellow-usage",
      viewBox: "0 0 16 18",
      url: "/" + "images/icons.3.109.2.svg#ic_punishment_yellow-usage",
      toString: function () {
        return this.url;
      }
    }